import { Box, Heading, Text } from '@chakra-ui/react';

export default function NotAuthorized() {
  return (
    <Box textAlign="center" py={10} px={6}>
      <Heading
        display="inline-block"
        as="h2"
        size="2xl"
        bgGradient="linear(to-r, teal.400, teal.600)"
        backgroundClip="text"
      >
        401
      </Heading>
      <Text fontSize="18px" mt={3} mb={2}>
        Not Authorized
      </Text>
      <Text color={'gray.500'} mb={6}>
        You are not authorized to access this page
      </Text>
    </Box>
  );
}
